import Title from '@components/Feature/Title';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { LinkType, ToolBoxType } from 'src/types';

interface ToolBoxProps {
  toolBox: ToolBoxType;
}

const ToolBox = (props: ToolBoxProps) => {
  const { toolBox } = props;

  return (
    <section
      className={ivclass(
        'sm:iv-pt-80 md:iv-pt-64 lg:iv-pt-150 xl:iv-pt-150',
        'iv-px-20',
      )}
    >
      <div className={ivclass('xl:iv-container', 'iv-mx-auto')}>
        <div className={ivclass('xl:iv-pb-20')}>
          <Title
            plainTitle={toolBox.plainHeading}
            highlightedTitle={toolBox.highlightedHeading}
          />
        </div>
        <div
          className={ivclass(
            'iv-pt-50 sm:iv-pt-30',
            'sm:iv-w-[340px] md:iv-w-[690px] lg:iv-w-[1080px] xl:iv-w-[1440px]',
            'iv-mx-auto',
          )}
        >
          {toolBox.links.map((link, idx) => (
            <ToolLink key={idx} link={link} />
          ))}
        </div>
      </div>
    </section>
  );
};

interface ToolLinkProps {
  link: LinkType;
}

const ToolLink = ({ link }: ToolLinkProps) => {
  return (
    <a
      className={ivclass(
        'iv-inline-block',
        'iv-w-[320px] sm:iv-w-[150px]',
        'iv-bg-black-4',
        'iv-rounded-30',
        'iv-my-15 iv-mx-20 md:iv-mx-12 md:iv-my-12 sm:iv-mx-5 sm:iv-my-12',
        'iv-align-top',
        'iv-cursor-pointer',
        'iv-no-underline',
        'iv-text-body-4xl iv-m-body-4xl sm:iv-text-body-3xl sm:iv-m-body-3xl',
        'iv-font-semibold',
        'iv-bg-transparent',
      )}
      href={link.URL}
      target="_self"
    >
      {link.Name}
    </a>
  );
};

export default ToolBox;
